module.exports = __webpack_public_path__ + "img/small.18ec0e14.jpg";